<script setup lang="ts">
import { useMapSelect } from '@/shared/ui/VMapSelect'
import { onMounted, ref } from 'vue'
import './assets/style.scss'

const model = useMapSelect()

/* Определяем вызов события для использования в хранилище */
const emits = defineEmits(['selected'])
model.emits = emits

/* Переменные для работы с картой */
const canvas = ref<HTMLElement | null>(null)
const startCoords = ref<number[]>([0, 0])
const endCoords = ref<number[]>([0, 0])

/**
 * Функция рисования области выделения через requestAnimationFrame
 */
const updateCanvas = () => {
  if (canvas.value) {
    canvas.value.style.top = Math.min(startCoords.value[1], endCoords.value[1]) + 'px'
    canvas.value.style.left = Math.min(startCoords.value[0], endCoords.value[0]) + 'px'
    canvas.value.style.width = Math.abs(startCoords.value[0] - endCoords.value[0]) + 'px'
    canvas.value.style.height = Math.abs(startCoords.value[1] - endCoords.value[1]) + 'px'
  }
}

/**
 * ФФункция регистрации окончания выделения
 * @param event
 */
const handleMouseMove = (event: MouseEvent) => {
  if (canvas.value && model.isSelect) {
    endCoords.value = [event.clientX, event.clientY]
    requestAnimationFrame(updateCanvas)
  }
}

/**
 * Функция регистрации начала выделения
 * @param event
 */
const handleMouseDown = (event: MouseEvent) => {
  if (model.isDisabled) return
  if (event.shiftKey) model.isSelect = true

  if (canvas.value && model.isSelect) {
    startCoords.value = [event.clientX, event.clientY]
    endCoords.value = [event.clientX, event.clientY]
    requestAnimationFrame(updateCanvas)
  }
}

/**
 * Регистрируем обработчики событий
 */
onMounted(() => {
  document.addEventListener('mousedown', handleMouseDown)
  document.addEventListener('mousemove', handleMouseMove)

  return () => {
    document.removeEventListener('mousedown', handleMouseDown)
    document.removeEventListener('mousemove', handleMouseMove)
  }
})
</script>

<template>
  <div v-if="model.isSelect" class="v-map-select__canvas" ref="canvas"></div>
</template>
